import React, { useCallback } from 'react';
import { userInfoStore } from '../../store/userInfoStore';

function SelectedQuickBets() {
  const { setBetAmount, quickBets, betAmount } = userInfoStore;

  const handleSelectQuickBet = useCallback(
    (amount) => {
      setBetAmount(amount);
    },
    [setBetAmount]
  );

  return (
    <div className='numpad-number-row'>
      {quickBets.slice(1, 6).map((el) => {
        return (
          <div className='numpad-number-item' key={el} onClick={() => handleSelectQuickBet(el)}>
            <button className={`numpad-number-btn ${betAmount === el ? 'selected' : ''}`}>
              {el}
            </button>
          </div>
        );
      })}
    </div>
  );
}
export default SelectedQuickBets;
